import { render, staticRenderFns } from "./venuethree.vue?vue&type=template&id=19c3bc19&scoped=true&"
import script from "./venuethree.vue?vue&type=script&lang=js&"
export * from "./venuethree.vue?vue&type=script&lang=js&"
import style0 from "./venuethree.vue?vue&type=style&index=0&id=19c3bc19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c3bc19",
  null
  
)

export default component.exports